module.exports = "images/logo_okoo.cbf8732f.png";